import React, { useEffect, useState } from 'react';

import { useNavigate, Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Header from '../../component/layout/Header';
import Footer from '../../component/layout/Footer';
import Page from '../../component/layout/Page';
import Title from '../../component/layout/Title';

import moment from 'moment';
import axios from 'axios';
import { mainurl, fileurl } from '../../MainUrl';
import { notification } from '../../component/hocs/notification';
import DataTable from 'react-data-table-component';
import { custTableStyles } from '../../style/color';
import { confirm } from '../../component/utility/confirm';

import {
  Row, Col, Card, CardBody, Button, Input, InputGroupText, InputGroup, Modal, ModalHeader, ModalBody, Form, Label, Spinner, FormGroup
} from 'reactstrap';

import { FaEdit, FaPlusCircle, FaSearch, FaMinusCircle, FaFileAlt, FaCloudDownloadAlt } from 'react-icons/fa';

const paginationComponentOptions = {
  selectAllRowsItem: true,
};

const SiteList = () => {
  //redux (From site)
  const log_data = useSelector((state) => state.logged.loginData);
  const [loading, setLoading] = useState(false);

  const [tableData, setTableData] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [selectedItem, setSelectedItem] = useState('');
  const [model, setModel] = useState('');
  const [manufacturer, setManufacturer] = useState('');

  const [siteModal, setSiteModal] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    get_list_handler();
  }, []);

  const get_list_handler = () => {

    let list = [
      {
        "sl": 1,
        "Name": 'Engine Block',
        "Model_No": 'TSEB1209',
        "Manufacturer": 'Tata Motors',
        "action": <>
          <FaEdit className='cursor ms-3' size={20} color="#6da845" />
        </>
      },
      {
        "sl": 2,
        "Name": 'Air Filter',
        "Model_No": 'BFAF9832',
        "Manufacturer": 'Bharat Forge',
        "action": <>
          <FaEdit className='cursor ms-3' size={20} color="#6da845" />
        </>
      },
      {
        "sl": 3,
        "Name": 'Transmission Gearbox',
        "Model_No": 'MHTG4532',
        "Manufacturer": 'Mahindra & Mahindra',
        "action": <>
          <FaEdit className='cursor ms-3' size={20} color="#6da845" />
        </>
      },
      {
        "sl": 4,
        "Name": 'Hydraulic Pump',
        "Model_No": 'XYZH5029',
        "Manufacturer": 'Star Hydraulics',
        "action": <>
          <FaEdit className='cursor ms-3' size={20} color="#6da845" />
        </>
      }
    ]

    setTableData(list);
    setFilterData(list);
  }

  const [itemsData, setItemsData] = useState([
    {
      name: 'Engine Block',
      models: [
        { modelNo: 'TSEB1209', manufacturer: 'Tata Motors' },
        { modelNo: 'TSEB1210', manufacturer: 'Bharat Forge' },
      ],
    },
    {
      name: 'Air Filter',
      models: [
        { modelNo: 'BFAF9832', manufacturer: 'Bharat Forge' },
        { modelNo: 'AF1234', manufacturer: 'Tata Motors' },
      ],
    },
    {
      name: 'Transmission Gearbox',
      models: [
        { modelNo: 'MHTG4532', manufacturer: 'Mahindra & Mahindra' },
      ],
    },
    {
      name: 'Hydraulic Pump',
      models: [
        { modelNo: 'XYZH5029', manufacturer: 'Star Hydraulics' },
      ],
    },
  ]);

  const addItemToData = (itemName, modelNo, manufacturer) => {
    const existingItem = itemsData.find(item => item.name === itemName);
    const newModel = { modelNo, manufacturer };

    if (existingItem) {
      setItemsData(prevData =>
        prevData.map(item =>
          item.name === itemName
            ? { ...item, models: [...item.models, newModel] }
            : item
        )
      );
    } else {
      const newItem = {
        name: itemName,
        models: [newModel],
      };
      setItemsData(prevData => [...prevData, newItem]);
    }
  };

  const site_add_handler = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      addItemToData(selectedItem, model, manufacturer);
      let notify = notification({ message: "Site Added Successfully", type: 'success' });
      notify();
      setSiteModal(false);
      get_list_handler();
    } catch (error) {
      let notify = notification({ message: "Failed! Try Again", type: 'error' });
      notify();
    } finally {
      setLoading(false);
    }
  };

  const filter_data_handler = (e) => {
    const query = e.target.value.toLowerCase().trim();
    const filteredData = tableData.filter(item =>
      item?.Name?.toLowerCase().includes(query) ||
      item?.Model_No?.toLowerCase().includes(query) ||
      item?.Manufacturer?.toLowerCase().includes(query)
    );
    setFilterData(filteredData);
  };

  return (
    <div>
      <Header />
      <Page>
        <Row className='mb-3'>
          <Col xs={3} className='mb-1'>
            <Title pageTitle="Site List" />
          </Col>
          <Col md={6} className='d-flex justify-content-end align-items-center'>
            <Button className='me-2' color='primary' onClick={() => setSiteModal(true)}><FaPlusCircle size={20} /> Add Item </Button>
          </Col>
          <Col xs={3} className='mb-1 text-end'>
            <InputGroup>
              <InputGroupText>
                <FaSearch />
              </InputGroupText>
              <Input size="sm" type="text" placeholder='Search' onChange={filter_data_handler} />
            </InputGroup>
          </Col>
        </Row>
        <Card color="primary" outline className='mb-3'>
          <CardBody>
            <Row>
              <Col md={12} className='mb-2'>
                <DataTable
                  className='mb-3'
                  customStyles={custTableStyles}
                  columns={[
                    {
                      name: '#',
                      selector: row => row.sl,
                      width: "50px"
                    },
                    {
                      name: 'Site Name',
                      selector: row => row.Name,
                    },
                    {
                      name: 'Item Name',
                      selector: row => row.Name,
                    },
                    {
                      name: 'Model No',
                      selector: row => row.Model_No,
                      wrap: true
                    },
                    {
                      name: 'Manufacturer',
                      selector: row => row.Manufacturer,
                      wrap: true,
                    },
                    {
                      name: 'Action',
                      selector: row => row.action,
                    },
                  ]}
                  data={filterData}
                  highlightOnHover
                  pagination
                  paginationComponentOptions={paginationComponentOptions}
                  progressPending={loading}
                />
              </Col>
            </Row>
          </CardBody>
        </Card>
        <Modal
          centered
          scrollable
          size="lg"
          isOpen={siteModal}
          toggle={() => setSiteModal(!siteModal)}
        >
          <ModalHeader toggle={() => setSiteModal(!siteModal)}>
            Add Item
          </ModalHeader>
          <ModalBody className=''>
            <Form onSubmit={site_add_handler}>
              <Row>
                <Col xs={12} className='mb-2'>
                  <Label for="site_name">Site Name*</Label>
                  <Input
                    id="name"
                    name="name"
                    placeholder="Enter Site Name"
                    value={selectedItem}
                    onChange={(e) => setSelectedItem(e.target.value)}
                    required
                  />
                </Col>
                <Col xs={6} className='mb-2'>
                  <Label for="site_name">Item Name*</Label>
                  <Input
                    id="name"
                    name="name"
                    placeholder="Enter Item Name"
                    value={selectedItem}
                    onChange={(e) => setSelectedItem(e.target.value)}
                    required
                  />
                </Col>

                <Col xs={6} className='mb-2'>
                  <Label for="model_no">Model No*</Label>
                  <Input
                    id="model_no"
                    name="model_no"
                    placeholder="Enter Model Number"
                    value={model}
                    onChange={(e) => setModel(e.target.value)}
                    required
                  />
                </Col>

                <Col xs={6} className='mb-2'>
                  <Label for="manufacturer">Manufacturer*</Label>
                  <Input
                    id="manufacturer"
                    name="manufacturer"
                    placeholder="Enter Manufacturer"
                    value={manufacturer}
                    onChange={(e) => setManufacturer(e.target.value)}
                    required
                  />
                </Col>

                <Col xs={12} className='mb-2'>
                  <b>Note:</b> (*) Mark fields are mandatory.
                </Col>

                <Col xs={12} className='mb-2 text-end'>
                  <Button className='mt-2' block color='primary' disabled={loading}>
                    ADD {loading && <Spinner color="secondary">Loading...</Spinner>}
                  </Button>
                </Col>
              </Row>
            </Form>
          </ModalBody>
        </Modal>
      </Page >

      <Footer />
    </div >
  )
}

export default SiteList;